import React, { useContext, useEffect, useState } from "react";
import {
    create_product_transection,
    get_product_transection1,
    // delete_product_transection
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import { Deletemodel, Pagination } from "../../Common/Functions";
import { isReadonlyRoute, NaviGate } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import { useLocation } from "react-router-dom";
import { EditEndProductTransaction } from "./eForm";

const Eproduct = () => {
    const { pathname } = useLocation();
    const readonly = isReadonlyRoute(pathname);
    const { showLoader, hideLoader } = useContext(WarehouseContext);

    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [addOrEdit, setAddOrEdit] = useState(true);

    const [deleteID, setDeleteID] = useState("");
    const [deletemodel, showDeletemodel] = useState(false);

    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [viewType, setViewType] = useState("add"); // "add" or "taken"

    const rolesPerPage = 10;

    // useEffect(() => {
    //     fetchProducts();
    // }, []);

    useEffect(() => {
        fetchProducts();
    }, [viewType]);

    const handledeletemodel = (ID) => {
        showDeletemodel(true);
        setDeleteID(ID);
    };

    // const fetchProducts = async (page = 1, text = "") => {
    //     showLoader();
    //     try {
    //         const response = await get_product_transection(page, rolesPerPage, text);
    //         if (response.data && response.data.data) {
    //             setProducts(response.data.data);
    //             setTotalPages(response.data.pagination?.total_pages || 1);
    //         }
    //     } catch (error) {
    //         console.error("Error fetching products:", error);
    //         toast.error("Failed to fetch products");
    //     } finally {
    //         hideLoader();
    //     }
    // };

    const fetchProducts = async (page = 1, text = "") => {
        showLoader();
        try {
            const addTakenParam = viewType === "add" ? "1" : "0";
            const response = await get_product_transection1(page, rolesPerPage, text, addTakenParam);
            if (response.data && response.data.data) {
                setProducts(response.data.data);
                setTotalPages(response.data.pagination?.total_pages || 1);
            }
        } catch (error) {
            console.error("Error fetching raw materials:", error);
            toast.error("Failed to fetch raw materials");
        } finally {
            hideLoader();
        }
    };



    const openAddModal = () => {
        setAddOrEdit(true);
        setSelectedProduct(null);
        setShowEditModal(true);
    };

    const openEditModal = (product) => {
        setSelectedProduct(product);
        setAddOrEdit(false);
        setShowEditModal(true);
    };

    const handleDelete = async () => {
        // if (!deleteID) {
        //     toast.error("No product selected to delete");
        //     return;
        // }

        // try {
        //     await delete_product_transection(deleteID);
        //     showDeletemodel(false);
        //     toast.success("Product transaction deleted");
        //     fetchProducts(currentPage);
        // } catch (error) {
        //     console.error("Error deleting product:", error);
        //     toast.error("Error deleting product transaction");
        // }
    };

    const handlePageChange = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
        fetchProducts(pageNumber);
    };

    const handleSearch = async (text) => {
        fetchProducts(1, text);
        setCurrentPage(1);
    };
    const handleViewTypeChange = (type) => {
        setViewType(type);
        setCurrentPage(1);
    };

    return (
        <div className="page-wrappers">
            <div className="page-content">
                <NaviGate />
                <div className="mb-0 d-flex justify-content-between align-items-center">
                    <h6
                        className="mb-0 text-uppercase"
                        style={{ fontFamily: "poppins" }}
                    >
                        End Product Transactions
                    </h6>
                    {/* {!readonly && (
                        <button
                            type="button"
                            onClick={() => openAddModal()}
                            className="btn btn-primary mb-0"
                            style={{ fontFamily: "poppins" }}
                        >
                            Add Product Transaction
                        </button>
                    )} */}
                </div>
                <hr className="mt-1" />

                <div className="card">
                    <div className="card-body">
                        <div className="row mb-3 align-items-center">

                            <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-2">
                                <div
                                    className="d-flex position-relative"
                                    style={{ width: "100%" }}
                                >
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Search..."
                                        onChange={(e) => handleSearch(e.target.value)}
                                    />
                                    <img
                                        src="/assets/images/icons/search.png"
                                        alt="Search Icon"
                                        style={{
                                            position: "absolute",
                                            right: "12px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            height: "18px",
                                            pointerEvents: "none",
                                        }}
                                    />
                                </div>

                            </div>
                            <div className="col-12 col-md-6 col-lg-8 text-end">
                                <button
                                    type="button"
                                    className={`btn btn-sm ${viewType === "add" ? "btn-primary" : "btn-outline-primary"} me-2`}
                                    onClick={() => handleViewTypeChange("add")}
                                >
                                    Add List
                                </button>
                                <button
                                    type="button"
                                    className={`btn btn-sm ${viewType === "taken" ? "btn-primary" : "btn-outline-primary"}`}
                                    onClick={() => handleViewTypeChange("taken")}
                                >
                                    sales List
                                </button>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table
                                className="table table-striped table-sm table-bordered"
                                style={{ width: "100%", fontFamily: "poppins" }}
                            >
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Product</th>
                                        {!readonly && viewType === "add" && (<th>Date</th>)}
                                        <th>Quantity</th>
                                        {!readonly && viewType === "add" && (<th>Remaining</th>)}
                                        {/* {!readonly && viewType === "add" && <th>Actions</th>} */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {products.map((product, index) => (
                                        <tr key={product.id}>
                                            <td>{(currentPage - 1) * rolesPerPage + index + 1}</td>
                                            <td>{product.product_name || product.title}</td>
                                            {!readonly && viewType === "add" && (<td>
                                                {(() => {
                                                    const d = new Date(product.date_time);
                                                    const date = d.toLocaleDateString("en-GB");
                                                    const time = d.toLocaleTimeString("en-GB", {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: true
                                                    });
                                                    return `${date} ${time}`;
                                                })()}
                                            </td>
                                            )}
                                            <td>{product.qty}{""}{product.units}</td>
                                            {!readonly && viewType === "add" && (<td>{product.remaining || "0"}{''}{product.units}</td>)}
                                            {/* <td>{new Date(product.expdate).toLocaleDateString()}</td> */}
                                            {/* {!readonly && viewType === "add" && (
                                                <td>
                                                    <img
                                                        src="/assets/images/icons/edit.png"
                                                        onClick={() => openEditModal(product)}
                                                        height="16px"
                                                        alt="Edit"
                                                        style={{ cursor: "pointer" }}
                                                    />
                                                    &nbsp;&nbsp;&nbsp;
                                                    <img
                                                        src="/assets/images/icons/delete.png"
                                                        onClick={() => handledeletemodel(product.id)}
                                                        height="16px"
                                                        alt="Delete"
                                                        style={{ cursor: "pointer" }}
                                                    />
                                                </td>
                                            )} */}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {deletemodel && (
                <Deletemodel
                    setShowModal={showDeletemodel}
                    handleDelete={handleDelete}
                />
            )}

            {showEditModal && (
                <EditEndProductTransaction
                    showModal={showEditModal}
                    setShowModal={setShowEditModal}
                    fetchProducts={fetchProducts}
                    selectedProduct={selectedProduct}
                    AddorEdit={addOrEdit}
                    setCurrentPage={setCurrentPage}
                />
            )}
        </div>
    );
};

export default Eproduct;
